var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5216 25.2001L15.9616 17.6401C15.3616 18.1201 14.6716 18.5001 13.8916 18.7801C13.1116 19.0601 12.2816 19.2001 11.4016 19.2001C9.22156 19.2001 7.37656 18.4451 5.86656 16.9351C4.35656 15.4251 3.60156 13.5801 3.60156 11.4001C3.60156 9.2201 4.35656 7.3751 5.86656 5.8651C7.37656 4.3551 9.22156 3.6001 11.4016 3.6001C13.5816 3.6001 15.4266 4.3551 16.9366 5.8651C18.4466 7.3751 19.2016 9.2201 19.2016 11.4001C19.2016 12.2801 19.0616 13.1101 18.7816 13.8901C18.5016 14.6701 18.1216 15.3601 17.6416 15.9601L25.2016 23.5201L23.5216 25.2001ZM11.4016 16.8001C12.9016 16.8001 14.1766 16.2751 15.2266 15.2251C16.2766 14.1751 16.8016 12.9001 16.8016 11.4001C16.8016 9.9001 16.2766 8.6251 15.2266 7.5751C14.1766 6.5251 12.9016 6.0001 11.4016 6.0001C9.90156 6.0001 8.62656 6.5251 7.57656 7.5751C6.52656 8.6251 6.00156 9.9001 6.00156 11.4001C6.00156 12.9001 6.52656 14.1751 7.57656 15.2251C8.62656 16.2751 9.90156 16.8001 11.4016 16.8001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartSearchIcon);
export default __webpack_public_path__ + "static/media/SmartSearchIcon.7f67b52bf92499b16f158d187ba22087.svg";
export { ForwardRef as ReactComponent };